import { render } from "./alternate-url.vue?vue&type=template&id=5b05eba9&scoped=true"
import script from "./alternate-url.vue?vue&type=script&lang=js"
export * from "./alternate-url.vue?vue&type=script&lang=js"

import "./alternate-url.vue?vue&type=style&index=0&id=5b05eba9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b05eba9"]])

export default __exports__